export const RESET_ZOOM_BUTTON_LABEL = 'Reset zoom';
export const INCREASE_BUTTON_LABEL = '+';
export const DECREASE_BUTTON_LABEL = '−';
